'use strict';

/**
 * All JS for any action of the ProjectsController on the server side
 */
waApp.controllers.Projects = {
	_addAndEdit: function () {
		waUtils.inputLanguageToggle();
		waUtils.stateSelect('#country-id', '#state-id');

		let getPhotoCount = function () {
			return parseInt(
				$('.projects-photo-container img').length,
				10
			);
		};

		let allowedPhotoCount = parseInt($('#photos').data('allowed-count'), 10);

		let togglePhotoUploader = function () {
			let dropArea = $('#dropzone');
			let photoCount = getPhotoCount();

			if (allowedPhotoCount === -1) {
				dropArea.show();
				return;
			}

			if (photoCount < allowedPhotoCount) {
				dropArea.show();
			} else {
				dropArea.hide();
			}
		};

		// Converting the comma separated list of clients into an array
		// and set it to the select2 input to make its appearance fancy in the
		// Frontend
		let clients = ($('#clients').val().split(','));
		for (let i = 0; i < clients.length; i++) {
			let client = clients[i].trim();
			if (client.length === 0) {
				continue;
			}
			$('#clients-select').append('<option selected="selected" value="' + client + '">' + client + '</option>');
		}

		$('#clients-select').select2({
			tags: true,
			multiple: true,
			tokenSeparators: [','],
			minimumResultsForSearch: Infinity
		});

		// Converting the comma separated list of team members into an array
		// and set it to the select2 input to make its appearance fancy in the
		// Frontend
		let team = ($('#team').val().split(','));

		for (let i = 0; i < team.length; i++) {
			let teamEntry = team[i].trim();
			if (teamEntry.length === 0) {
				continue;
			}
			$('#team-select').append('<option selected value="' + teamEntry + '">' + teamEntry + '</option>');
		}

		$('#team-select').select2({
			tags: true,
			multiple: true,
			tokenSeparators: [','],
			minimumResultsForSearch: Infinity
		});

		// Declaring the select2 for all the inputs that need it
		$('#building-types-ids').select2();
		$('#country-id').select2();

		// Getting vars we'll need later on
		let projectId = $('.project-form').data('project-id');
		let partnerTemplate = '';

		$.ajax({
			headers: {
				Accept: 'text/html'
			},
			url: '/projects/partnerCompaniesTemplate',
			type: 'GET'
		})
			.fail(function () {
				// Error
			})
			.done(function (data) {
				partnerTemplate = data;
			});

		// Speeds up the parsing later
		Mustache.parse(partnerTemplate);

		$('.add-partner-company').on('click', function (event) {
			event.preventDefault();

			var partnerCount = $('#partner-companies li').length;
			let copy = partnerTemplate;

			copy = copy.replace('project-partners-0-id', 'project-partners-' + partnerCount + '-id');
			copy = copy.replace('project-partners-0-name', 'project-partners-' + partnerCount + '-name');
			copy = copy.replace('project-partners-0-role', 'project-partners-' + partnerCount + '-role');

			copy = copy.replace('project_partners[0][id]', 'project_partners[' + partnerCount + '][id]');
			copy = copy.replace('project_partners[0][name]', 'project_partners[' + partnerCount + '][name]');
			copy = copy.replace('project_partners[0][role]', 'project_partners[' + partnerCount + '][role]');

			let languages = window.formLanguages;

			if (languages) {
				languages.forEach((language) => {
					copy = copy.replaceAll(
						'project_partners[0][translations][' + language + '][id]',
						'project_partners[' + partnerCount + '][translations][' + language + '][id]'
					);

					copy = copy.replaceAll(
						'project_partners[0][translations][' + language + '][locale]',
						'project_partners[' + partnerCount + '][translations][' + language + '][locale]'
					);
					copy = copy.replaceAll(
						'project_partners[0][translations][' + language + '][name]',
						'project_partners[' + partnerCount + '][translations][' + language + '][name]'
					);
					copy = copy.replaceAll(
						'project_partners[0][translations][' + language + '][role]',
						'project_partners[' + partnerCount + '][translations][' + language + '][role]'
					);
					copy = copy.replaceAll(
						'project-partners-0-name',
						'project-partners-' + partnerCount + '-name'
					);
					copy = copy.replaceAll(
						'project-partners-0-translations-' + language + '-name',
						'project-partners-' + partnerCount + '-translations-' + language + '-name'
					);
				})
			}

			$('#partner-companies').append(copy);
			$('.form-group').addClass('float-label-control');
			$('.float-label-control').floatLabels();
			waUtils.inputLanguageToggle();

			partnerCount++;
		});

		$('#partner-companies').on('click', '.remove', function (event) {
			event.preventDefault();
			$(this).parent('li').remove();
		});

		$('#project-status-id').on('change', function (e) {
			let value = $(this).val();
			// Fucking integer values...
			// 5  = Under Construction
			// 6  = Built
			// 11 = Design
			// See https://github.com/World-Architects/WA3/issues/93
			// See \App\Model\StaticLists.php
			// See \App\Model\BuildingStatus.php
			if (value == 5) {
				$('#build-question').hide();
				$('#address-fields').show();
				$('#year').show();
			} else if (value == 6) {
				$('#build-question').hide();
				$('#address-fields').show();
				$('#year').show();
			} else if (value == 11) {
				$('#build-question').show();
				$('#address-fields').show();
				$('#year').show();
				$('input[name=built]').trigger('change');
			} else {
				$('#build-question').hide();
				$('#address-fields').hide();
				$('#year').hide();
			}
		});

		$('#project-status-id').trigger('change');

		// This needs to be triggered ONLY inside the change event
		// In the code above, otherwise it will cause wrong behavior.
		// So all you need to do is
		// $('input[name=will_be_built]').on('click', function (e) {
		// 	let value = $('input[name=will_be_built]:checked').val();
		// 	if (value == 1) {
		// 		$('#address-fields').show();
		// 		$('#year').show();
		// 	} else {
		// 		$('#address-fields').hide();
		// 		$('#year').hide();
		// 	}
		// });

		if ($('input[name=will_be_built]:checked').val() == 1) {
			$('#address-fields').show();
			$('#year').show();
		}

		// Remove the photo from the list on click on the button / X
		$('#photos').on('click', 'a.delete', function (e) {
			e.preventDefault();

			console.log('is called');

			let imageId = $(this).data('image-id');

			$.ajax({
				url: '/files/delete/Projects/' + imageId + '.json',
				type: 'DELETE',
				dataType: 'json'
			})
				.fail(function () {
					// Error
				})
				.done(function () {
					$('#photos li[data-photo-id="' + imageId + '"]').remove();
					getPhotoCount();
					togglePhotoUploader();
				});
		});

		// Project Photos Sorting
		var unOrderedList = $("#photos").html();
		var sortingTimeout = null;
		$('#photos').sortable({
			handle: '.sort',
			start: function (event, ui) {
				ui.item.startPosition = ui.item.index();
			},
			update: function (event, ui) {
				// Clear any pending sort request to debounce rapid sorting
				if (sortingTimeout) {
					clearTimeout(sortingTimeout);
				}

				$('#photos').sortable('option', 'disabled', true);

				// Collect all image IDs in their current order
				var imageOrder = [];
				$('#photos li[data-photo-id]').each(function(index) {
					imageOrder.push({
						id: $(this).data('photo-id'),
						position: index + 1
					});
				});

				// Debounce to prevent race conditions during rapid sorting
				sortingTimeout = setTimeout(function() {
					$.ajax({
						headers: {
							Accept: 'application/json'
						},
						url: '/' + waApp.getLanguage() + '/files/update-position/Projects',
						type: 'POST',
						dataType: 'json',
						data: {
							order: imageOrder
						},
						success: function (data, textStatus, jqXHR) {
							$("#photos").sortable('option', 'disabled', false);
							console.log(data);
						},
						error: function (e) {
							$("#photos").html(unOrderedList);
							$("#photos").sortable('option', 'disabled', false);
							$("#photos").sortable("refreshPositions");
						}
					});
				}, 300); // 300ms debounce delay
			}
		});

		$('#photos').on('change', 'input[type=checkbox]', function (event) {
			$('#photos input[type=checkbox]:checked').removeAttr('checked');
			$(this).prop('checked', true);
		});

		// Trigger it once to hide the uploader if required
		togglePhotoUploader();
	},
	add: function () {
		waApp.controllers.Projects._addAndEdit();
	},
	edit: function () {
		waApp.controllers.Projects._addAndEdit();
	}
};
